export enum RingSize  {
  SMALL = 14,
  MEDIUM = 26,
  LARGE = 38
}
